/* eslint-disable no-useless-constructor */
import React, { useRef, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import styles from './Confirmation.module.scss'
import ContactInformation from './ContactInformation'
import PrintComponent from './PrintComponent'
import SaveCopy from './SaveCopy'

export const PrintContent1 = ({ t, i18n, emailAddress, paymentTransactionNum, transId, transOwner }) => {
  const getPayDefaultedFinesUrl = () => {
    const origin = window.location.origin
    if (origin.includes('dev-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-rmvadminfee.ds4u.novascotia.dev/en/fines-question'
        : 'https://dev-rmvadminfee.ds4u.novascotia.dev/fr/amendes-question'
    } else if (origin.includes('test-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-rmvadminfee.ds4u.novascotia.dev/en/fines-question'
        : 'https://test-rmvadminfee.ds4u.novascotia.dev/fr/amendes-question'
    } else if (origin.includes('uat-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-rmvadminfee.ds4u.novascotia.dev/en/fines-question'
        : 'https://uat-rmvadminfee.ds4u.novascotia.dev/fr/amendes-question'
    } else {
      return i18n.language === 'en'
        ? 'https://rmvadminfeepayment.novascotia.ca/en/fines-question'
        : 'https://rmvadminfeepayment.novascotia.ca/fr/amendes-question'
    }
  }

  const payDefaultedFinesUrl = getPayDefaultedFinesUrl()

  const handleGoBackToStart = (e) => {
    e.preventDefault()
    const url = getPayDefaultedFinesUrl()
    window.location.replace(url)
  }

  return (
    <div className={'container'}>
      <div style={{ display: 'flex', marginLeft: '-60px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
          <div className={'col-xs-1 ' + styles['success_margin_right']}>
            <i className="fa fa-check-circle fa-2x" aria-hidden="true"></i>
          </div>
          <div style={{ flexGrow: 1, backgroundColor: 'green', width: '5px' }} />
        </div>
        <div style={{ flexGrow: 1 }}>
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h1 style={{ color: 'green' }}>{t('receive_confirmation.title')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h2 style={{ marginTop: '0px' }}>
                  {t('receive_confirmation.transaction_number')} <strong>{paymentTransactionNum}</strong>
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h4 style={{ marginBottom: '15px', marginTop: '0px' }}>{t('receive_confirmation.we_have_emailed')}</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <p>{t('receive_confirmation.print_or_save')}</p>
              </div>
            </div>
            <div className="print_no_display">
              <div className="row">
                <div style={{ display: 'flex', flexGrow: 1, marginLeft: '10px' }}>
                  <div className={styles['display_flex']}>
                    <div className={styles['back_center']}>
                      {typeof InstallTrigger !== 'undefined' || /*@cc_on!@*/ false || !!document.documentMode ? null : (
                        <PrintComponent transId={transId} transOwner={transOwner} />
                      )}
                      <SaveCopy transId={transId} transOwner={transOwner} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <a href={payDefaultedFinesUrl} className={styles['all_finished_link']} onClick={handleGoBackToStart}>
                    {t('receive_confirmation.all_finished')}
                    <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ReceiveConfirmationView = ({ t, i18n, setIsError }) => {
  const pageElem = useRef()
  const location = useLocation()

  const [paymentTransactionNum, setPaymentTransactionNum] = useState('')
  const [transId, setTransId] = useState('123456')
  const [transOwner, setTransOwner] = useState('test Test')
  const [emailAddress, setEmailAddress] = useState('')

  useEffect(() => {
    try {
      if (!location.state) {
        return
      }
      if (location.state.transNum) {
        setPaymentTransactionNum(location.state.transNum)
      }
      if (location.state.emailAddress) {
        setEmailAddress(location.state.emailAddress)
      }
      if (location.state.transId) {
        setTransId(location.state.transId)
      }
      if (location.state.transOwner) {
        setTransOwner(location.state.transOwner)
      }
      if (location.state && location.state.transNum && location.state.emailAddress && location.state.transId && location.state.transOwner) {
        setTransId(location.state.transId)
        setTransOwner(location.state.transOwner)
        setEmailAddress(location.state.emailAddress)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [location.state, setIsError])

  return (
    <React.Fragment>
      <div ref={pageElem} style={{ marginBottom: '2rem' }}>
        <PrintContent1
          i18n={i18n}
          t={t}
          emailAddress={emailAddress}
          paymentTransactionNum={paymentTransactionNum}
          transId={transId}
          transOwner={transOwner}
        />
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-8">
              <h2>{t('receive_confirmation.what_happens_next')}</h2>
              <div className="row">
                <div className="col-xs-12">
                  <strong>{t('receive_confirmation.confirmation_email_title')}</strong>
                  <br />
                  {t('receive_confirmation.confirmation_email')}
                  {emailAddress}
                  <br />
                  {t('receive_confirmation.confirmation_email_info')}
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-xs-12">
                  <strong>{t('receive_confirmation.payment_processed')}</strong>
                  <br />
                  {t('receive_confirmation.payment_processed_info')}
                </div>
              </div>
              <br />
              <h2>{t('receive_confirmation.if_you_have_questions')}</h2>
              <div className="row">
                <div className="col-xs-12">{t('receive_confirmation.confirmation_email_info')}</div>
              </div>
              <br />
              <ContactInformation />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(ReceiveConfirmationView)
